export const EMPTY_OBJECT = {};
export const EMPTY_FUNCTION = () => undefined;
export const DEFAULT_LIMIT_PROVIDER = 30;
export const DEFAULT_LIMIT_PLAN = 10;
